var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-view"},[_c('div',{ref:"echarts",staticClass:"box",attrs:{"id":_vm.echarts}})])
}
var staticRenderFns = []

export { render, staticRenderFns }